import { SetorList } from '../setor/Setor';

export interface UsuarioList {
  id: string;
  nome: string | null;
  tipo: string | null;
  login: string | null;
  cpf: string;
  ativo: boolean;
  administradorOuvidoria: boolean;
  administradorSite: boolean;
  setores: SetorList[];
}

export const ISusuarioList: UsuarioList = {
  id: '',
  nome: '',
  tipo: '',
  cpf: '',
  login: '',
  ativo: false,
  administradorOuvidoria: false,
  administradorSite: false,
  setores: []
};
export interface UsuarioAddRemoveSetorDTO {
  idSetor: string;
  idUsuario: string | null;
}
